import React, { Component,Fragment } from 'react';
import { Row, Col, ModalFooter, Button } from 'reactstrap';
import ImageDetailsModal from '../Plugins/MainModals/ImageDetailsModal';
class PendingAccionProvider extends Component {

	open_modal = (modal) => {
        this.refs[modal].toggleModal();
    };

   	render () {
   		var data = this.props.data;
		return <Fragment>

			<Row className="justify-content-center">
				{
					data && data.provider && data.values &&
						<Fragment>
							<Col>
								<div className="py-3 mr-3 float-left">
									<img
										ref={ 'provider' }
										onError={ ()=>this.refs[`provider`].src= ' https://dondemand.sfo2.cdn.digitaloceanspaces.com/avatars/avatar-repartidor.png' }
										className="avatar_lg"
										src={ data.provider.avatar_url }
										alt={ 'actual_image' }
									/>
									<span className="avatar-status badge-success"></span>
								</div>
								<div><strong>{ data.provider.name }</strong> </div>
								<small className="text-muted">
									<i>@</i> { data.provider.email }<br/>
								</small>
								<small className="text-muted">
									<i className="icon-phone"></i> { data.provider.phone }
								</small>
								<small className="text-muted" style={{width:'70%',display:'inline-block'}}>
									<i className="fa fa-pencil-square-o"></i> {data.provider.profile_data.extract}
								</small>

							</Col>
							<Col>
								<strong>Cambios a aprobar:  </strong>
								{
									data.values.avatar_url &&
										<Fragment>
											<div className="py-3 mr-3 float-left">
												<img
													ref={'provider'}
													onError={() => this.refs[`provider`].src = 'https://dondemand.sfo2.cdn.digitaloceanspaces.com/avatars/avatar-repartidor.png' }
													className="avatar_lg updated pointer"
													src={ data.values.avatar_url }
													alt={ 'new_image' }
													onClick={() => this.open_modal("imageDetail")}
												/>
											</div>
										</Fragment>
								}
								{
									data.values.profile_data && data.values.profile_data.extract ?
									<small className="text-info" style={{width:'70%',display:'inline-block'}}>
										<i className="fa fa-pencil-square-o"></i> { data.values.profile_data.extract }
									</small>
									:null
								}
							</Col>

						<ImageDetailsModal
							ref={"imageDetail"}
							reference={() =>
								this.open_modal("imageDetail")
							}
							image={data.values.avatar_url}
							title={`Solicitud realizada por: ${data.provider.name}`}
						/>
						
						</Fragment>
				}
			</Row>
			<ModalFooter>
				<Button
					color="primary"
					onClick={() => this.props.confirm()}
				>
					Aprobar
				</Button>
				<Button
					color="danger"
					onClick={() => this.props.refuse()}
				>
					Rechazar
				</Button>
			</ModalFooter>
		</Fragment>
	}
}

export default (PendingAccionProvider);



// WEBPACK FOOTER //
// ./src/views/Provider/pendingAccionProvider.jsx